import React from "react";
import { useTranslation } from "react-i18next";
import { CoreModal } from "../core-modal";
import { FREE_LIMIT, TransElement } from "../../../../utils";
import image from "../images/publish-limit-img.png";
import { useReactiveVar } from "@apollo/client";
import { publishLimitModal } from "../../../../graphql/state";

export const PublishLimitModal = () => {
  const { t } = useTranslation();
  const show = useReactiveVar(publishLimitModal);
  const onCancel = () => publishLimitModal(false);

  return (
    <CoreModal
      show={show}
      onCancel={onCancel}
      image={{
        src: image,
        width: 193,
        height: 142,
      }}
      title={t("payment.publishLimitTitle")}
      text={{
        innerText: (
          <TransElement
            i18nKey="payment.publishLimitText"
            values={{ count: FREE_LIMIT.PUBLISHED_PAGE }}
            components={{ br: <br /> }}
          />
        ),
        className: "col-md-10",
      }}
    />
  );
};
